import {
  ContactCard as DesignSystemContactCard,
  DeleteIcon,
  EditIcon,
  ResourceMenuActions,
} from '@all-manager/design-system-v2';
import { ProviderContactDatabase } from "../../../../../types";
import AddUpdateContactModal from "../../AddUpdateContactModal/AddUpdateContactModal";
import DeleteContactModal from "../../DeleteContactModal/DeleteContactModal";
import { useContactCard } from "./useContactCard";

type Props = {
  contact: ProviderContactDatabase;
}

export default function ContactCard(props: Props) {
  const hook = useContactCard();

  return (
    <>
      <DesignSystemContactCard
        name={props.contact.name}
        role={props.contact.role}
        phones={[props.contact.phone1, props.contact.phone2]}
        email={props.contact.email}
        action={hook.isAdmin ? (
          <ResourceMenuActions
            size="small"
            tooltip={`Options de ${props.contact.name}`}
            actions={[
              { id: 'edit', label: 'Modifier', icon: <EditIcon fontSize="small" />, onClick: hook.handleOpenEditModal },
              { id: 'delete', label: 'Supprimer', icon: <DeleteIcon fontSize="small" />, onClick: hook.handleOpenDeleteModal },
            ]}
          />
        ) : undefined}
      />

      {hook.isEditModalOpen ? (
        <AddUpdateContactModal
          providerId={props.contact.provider_id}
          contact={props.contact}
          onClose={hook.handleCloseEditModal}
        />
      ) : null}

      {hook.isDeleteModalOpen ? (
        <DeleteContactModal
          contact={props.contact}
          onClose={hook.handleCloseDeleteModal}
        />
      ) : null}
    </>
  );
}
